import React from 'react';
import Helmet from 'react-helmet';
import { useIntl } from 'react-intl';
import appMessages from '../containers/App.messages';

interface PageTitleProps {
  title: string;
  suffix?: string;
}

/**
 * Sets the page title in the format "<title> - <suffix>".
 *
 * The suffix defaults to "Log in with Atlassian account" but can be overridden
 * for pages that require a different suffix (e.g. the MFA enrollment flow).
 *
 * This component renders the full title directly rather than relying on
 * react-helmet's titleTemplate mechanism, which is incompatible with
 * React 18's concurrent renderer when used with React.lazy and Suspense.
 */
const PageTitle = ({ title, suffix }: PageTitleProps) => {
  const { formatMessage } = useIntl();
  const titleSuffix = suffix ?? formatMessage(appMessages.headTitle);
  return <Helmet title={`${title} - ${titleSuffix}`} />;
};

export default PageTitle;
